import BaseModel from "../base_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";
import I18n from "../../base/i18n.js.jsx";

import LoadCountriesUseCase from "../../use_cases/addresses/countries/list_countries_use_case.js";
import { ProfileAddressModel } from "./profile_address_model.js";
import SalutationEnum from "../../enums/salutation.js.jsx";
import TitleEnum from "../../enums/title.js.jsx";
import YesNoEnum from "../../enums/yes_no.js.jsx";

import { PhoneMask } from "../../constants.js";

class RawProfileModel extends BaseModel {
  rawFormFields(item = undefined) {
    const is_company = item && item.salutation == "firma"
    return [
      {
        name: "salutation",
        displayName: this.fieldDisplayName("salutation"),
        type: "enum",
        enum: SalutationEnum,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "title",
        displayName: this.fieldDisplayName("title"),
        type: "enum",
        enum: TitleEnum,
        allowClear: true,
        clearItem: I18n.t("enum.title.no_title"),
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "firstName",
        displayName: is_company ? this.fieldDisplayName("managingDirectorFirstName") : this.fieldDisplayName("firstName"),
        type: "text",
        readOnly: true,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "lastName",
        displayName: is_company ? this.fieldDisplayName("managingDirectorLastName") : this.fieldDisplayName("lastName"),
        type: "text",
        readOnly: true,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "companyName",
        displayName: this.fieldDisplayName("companyName"),
        type: "text",
        readOnly: true,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "birthDate",
        displayName: this.fieldDisplayName("birthDate"),
        type: "dateTime",
        format: "DD.MM.YYYY",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "birthPlace",
        displayName: this.fieldDisplayName("birthPlace"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "citizenship",
        displayName: this.fieldDisplayName("citizenship"),
        type: "model",
        useCase: LoadCountriesUseCase,
        foreignKey: "citizenshipId",
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "phoneNumber",
        displayName: this.fieldDisplayName("phoneNumber"),
        type: "phone",
        mask: PhoneMask,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "mobilePhoneNumber",
        displayName: this.fieldDisplayName("mobilePhoneNumber"),
        type: "phone",
        mask: PhoneMask,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "text",
        readOnly: true,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "address",
        type: "nestedModel",
        model: ProfileAddressModel,
        weight: 12
      },
      {
        name: "hasUsTaxLiability",
        displayName: this.fieldDisplayName("hasUsTaxLiability"),
        type: "enum",
        enum: YesNoEnum,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "politicallyExposed",
        displayName: this.fieldDisplayName("politicallyExposed"),
        type: "enum",
        enum: YesNoEnum,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "taxId",
        displayName: this.fieldDisplayName("taxId"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      }
    ]
  }

  i18nScope() {
    return "model.users.personal_info";
  }
}

const ProfileModel = new RawProfileModel();

export { RawProfileModel, ProfileModel }
